import { getErrorMessage } from '../util/ErrorUtils';
import axios from '../util/axiosConfig';

export const addUpdateReserveEventAPI = async (event) => {
  return await axios.post(`/api/v1/add-update-reserve?override=${event?.override ? true : false}`, event)
      .then(function (response) {
          if (response.data) {
              return { success: true, data: response.data };
          } else {
              return { success: false };
          }
      })
      .catch(function (error) {
          return { success: false, error: error };
      });
}

export const fetchReserveApi = async (resourceId) => {
  return await axios.get(`/api/v1/reserves`, {
      params: {
          "resourceId": resourceId
      }
  })
      .then(function (response) {
          if (response.data) {
              return { success: true, data: response.data };
          } else {
              return { success: false };
          }
      })
      .catch(function (error) {
          return { success: false, error: getErrorMessage(error) };
      });
}

export const fetchCalendarReserves = async (payload) => {
  return axios
    .post(`/api/v1/reserves-for-calendar`, payload)
    .then(function (response) {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch(function (error) {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const deleteReserveAPI = async (reservationId) => {
  return await axios.delete(`/api/v1/reserve?reservationId=${reservationId}`)
    .then(function (response) {
    if (response.data) {
      return { success: true, data: response.data };
    } else {
      return { success: false };
    }
  })
  .catch(function (error) {
    return { success: false, error: getErrorMessage(error) };
  });
}